// ⚠️ THIS FILE IS AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated by: scripts/generate-point-path.ts
// Source: src/types/path/fieldDefinitions.ts
// To modify: Update fieldDefinitions.ts and run: npm run generate:point

import { toDegrees } from '@/utils/';
import { AbstractPath } from './AbstractPath';
import { FIELDS_PER_POINT, Point, PointField } from './Point';
export abstract class GeneratedPath extends AbstractPath {
    // === Coordinates Accessors ===

    getLatitude(pointIndex: number): number {
        return super.getField(pointIndex, PointField.LATITUDE);
    }

    getLatitudeDeg(pointIndex: number): number {
        return toDegrees(super.getField(pointIndex, PointField.LATITUDE));
    }

    setLatitude(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.LATITUDE, value);
    }

    getLongitude(pointIndex: number): number {
        return super.getField(pointIndex, PointField.LONGITUDE);
    }

    getLongitudeDeg(pointIndex: number): number {
        return toDegrees(super.getField(pointIndex, PointField.LONGITUDE));
    }

    setLongitude(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.LONGITUDE, value);
    }

    getDistance(pointIndex: number): number {
        return super.getField(pointIndex, PointField.DISTANCE);
    }

    setDistance(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.DISTANCE, value);
    }

    getDx(pointIndex: number): number {
        return super.getField(pointIndex, PointField.DX);
    }

    setDx(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.DX, value);
    }

    // === Temporal Accessors ===

    getTime(pointIndex: number): number {
        return super.getField(pointIndex, PointField.TIME);
    }

    setTime(pointIndex: number, value: number | Date): void {
        const timestamp = value instanceof Date ? value.getTime() : value;
        super.setField(pointIndex, PointField.TIME, timestamp);
    }

    getTimeAsDate(pointIndex: number): Date {
        return new Date(this.getTime(pointIndex));
    }

    getElapsed(pointIndex: number): number {
        return super.getField(pointIndex, PointField.ELAPSED);
    }

    setElapsed(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.ELAPSED, value);
    }

    getDt(pointIndex: number): number {
        return super.getField(pointIndex, PointField.DT);
    }

    setDt(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.DT, value);
    }

    // === Angles Accessors ===

    getBearing(pointIndex: number): number {
        return super.getField(pointIndex, PointField.BEARING);
    }

    setBearing(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.BEARING, value);
    }

    // === 🏔️ Elevation Accessors ===

    getElevation(pointIndex: number): number {
        return super.getField(pointIndex, PointField.ELEVATION);
    }

    setElevation(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.ELEVATION, value);
    }

    // === 📐 Grade Accessors ===

    getGrade(pointIndex: number): number {
        return super.getField(pointIndex, PointField.GRADE);
    }

    setGrade(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.GRADE, value);
    }

    // === Radius Accessors ===

    getRadius(pointIndex: number): number {
        return super.getField(pointIndex, PointField.RADIUS);
    }

    setRadius(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.RADIUS, value);
    }

    // === Aero coef Accessors ===

    getAeroCoef(pointIndex: number): number {
        return super.getField(pointIndex, PointField.AERO_COEF);
    }

    setAeroCoef(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.AERO_COEF, value);
    }

    // === Cyclist wind Accessors ===

    getWindBearing(pointIndex: number): number {
        return super.getField(pointIndex, PointField.WIND_BEARING);
    }

    setWindBearing(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.WIND_BEARING, value);
    }

    getWindAlpha(pointIndex: number): number {
        return super.getField(pointIndex, PointField.WIND_ALPHA);
    }

    setWindAlpha(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.WIND_ALPHA, value);
    }

    // === ⚡ Power Physics Accessors ===

    getPAero(pointIndex: number): number {
        return super.getField(pointIndex, PointField.P_AERO);
    }

    setPAero(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.P_AERO, value);
    }

    getPGravity(pointIndex: number): number {
        return super.getField(pointIndex, PointField.P_GRAVITY);
    }

    setPGravity(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.P_GRAVITY, value);
    }

    getPRollingResistance(pointIndex: number): number {
        return super.getField(pointIndex, PointField.P_ROLLING_RESISTANCE);
    }

    setPRollingResistance(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.P_ROLLING_RESISTANCE, value);
    }

    getPWheelBearings(pointIndex: number): number {
        return super.getField(pointIndex, PointField.P_WHEEL_BEARINGS);
    }

    setPWheelBearings(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.P_WHEEL_BEARINGS, value);
    }

    // === ⚡ Power Cyclist Accessors ===

    getPInputPower(pointIndex: number): number {
        return super.getField(pointIndex, PointField.P_INPUT_POWER);
    }

    setPInputPower(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.P_INPUT_POWER, value);
    }

    getPCyclistProvidedOptimalPower(pointIndex: number): number {
        return super.getField(pointIndex, PointField.P_CYCLIST_PROVIDED_OPTIMAL_POWER);
    }

    setPCyclistProvidedOptimalPower(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.P_CYCLIST_PROVIDED_OPTIMAL_POWER, value);
    }

    getPCyclistProvidedOptimalPowerWithHarmonics(pointIndex: number): number {
        return super.getField(pointIndex, PointField.P_CYCLIST_PROVIDED_OPTIMAL_POWER_HARMONICS);
    }

    setPCyclistProvidedOptimalPowerWithHarmonics(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.P_CYCLIST_PROVIDED_OPTIMAL_POWER_HARMONICS, value);
    }

    getPCyclistPowerNeeded(pointIndex: number): number {
        return super.getField(pointIndex, PointField.P_CYCLIST_PROVIDED_POWER_NEEDED);
    }

    setPCyclistPowerNeeded(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.P_CYCLIST_PROVIDED_POWER_NEEDED, value);
    }

    getPCyclistProvidedMuscular(pointIndex: number): number {
        return super.getField(pointIndex, PointField.P_CYCLIST_PROVIDED_MUSCULAR);
    }

    setPCyclistProvidedMuscular(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.P_CYCLIST_PROVIDED_MUSCULAR, value);
    }

    getPCyclistProvidedWheel(pointIndex: number): number {
        return super.getField(pointIndex, PointField.P_CYCLIST_PROVIDED_WHEEL);
    }

    setPCyclistProvidedWheel(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.P_CYCLIST_PROVIDED_WHEEL, value);
    }

    // === ⚡ Power Post processed Accessors ===

    getPComputedTotalPower(pointIndex: number): number {
        return super.getField(pointIndex, PointField.P_COMPUTED_TOTAL_POWER);
    }

    setPComputedTotalPower(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.P_COMPUTED_TOTAL_POWER, value);
    }

    getPComputedWheelPower(pointIndex: number): number {
        return super.getField(pointIndex, PointField.P_COMPUTED_WHEEL_POWER);
    }

    setPComputedWheelPower(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.P_COMPUTED_WHEEL_POWER, value);
    }

    getPComputedPower(pointIndex: number): number {
        return super.getField(pointIndex, PointField.POWER);
    }

    setPComputedPower(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.POWER, value);
    }

    // === Speed & Motion Accessors ===

    getSpeed(pointIndex: number): number {
        return super.getField(pointIndex, PointField.SPEED);
    }

    setSpeed(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.SPEED, value);
    }

    getSpeedMax(pointIndex: number): number {
        return super.getField(pointIndex, PointField.SPEED_MAX);
    }

    setSpeedMax(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.SPEED_MAX, value);
    }

    getSpeedMaxIncline(pointIndex: number): number {
        return super.getField(pointIndex, PointField.SPEED_MAX_INCLINE);
    }

    setSpeedMaxIncline(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.SPEED_MAX_INCLINE, value);
    }

    getVirtSpeedCurrent(pointIndex: number): number {
        return super.getField(pointIndex, PointField.VIRT_SPEED_CURRENT);
    }

    setVirtSpeedCurrent(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.VIRT_SPEED_CURRENT, value);
    }

    // === Environmental Accessors ===

    getTemperature(pointIndex: number): number {
        return super.getField(pointIndex, PointField.TEMPERATURE);
    }

    setTemperature(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.TEMPERATURE, value);
    }

    getWindSpeed(pointIndex: number): number {
        return super.getField(pointIndex, PointField.WIND_SPEED);
    }

    setWindSpeed(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.WIND_SPEED, value);
    }

    getWindDirection(pointIndex: number): number {
        return super.getField(pointIndex, PointField.WIND_DIRECTION);
    }

    setWindDirection(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.WIND_DIRECTION, value);
    }

    // === Physiological Accessors ===

    getHeartRate(pointIndex: number): number {
        return super.getField(pointIndex, PointField.HEART_RATE);
    }

    setHeartRate(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.HEART_RATE, value);
    }

    getCadence(pointIndex: number): number {
        return super.getField(pointIndex, PointField.CADENCE);
    }

    setCadence(pointIndex: number, value: number): void {
        super.setField(pointIndex, PointField.CADENCE, value);
    }

    /**
     * Adds a new point with the provided data.
     * @param data Complete point data with all 36 properties
     * @returns The index of the newly added point
     */
    addPoint(data: Point): number {
        const pointIndex = this.pointCount;
        this.ensureCapacity(pointIndex + 1);

        // Increment point count first so bounds checking works
        this.pointCount++;

        const chunkIndex = Math.floor(pointIndex / this.CHUNK_SIZE);
        const pointInChunk = pointIndex % this.CHUNK_SIZE;
        const fieldOffset = pointInChunk * FIELDS_PER_POINT;

        // Set all fields from the provided data
        // Coordinates
        this.chunks[chunkIndex][fieldOffset + PointField.LATITUDE] = data.latitude;
        this.chunks[chunkIndex][fieldOffset + PointField.LONGITUDE] = data.longitude;
        this.chunks[chunkIndex][fieldOffset + PointField.DISTANCE] = data.distance;
        this.chunks[chunkIndex][fieldOffset + PointField.DX] = data.dx;

        // Temporal
        this.chunks[chunkIndex][fieldOffset + PointField.TIME] = data.time;
        this.chunks[chunkIndex][fieldOffset + PointField.ELAPSED] = data.elapsed;
        this.chunks[chunkIndex][fieldOffset + PointField.DT] = data.dt;

        // Angles
        this.chunks[chunkIndex][fieldOffset + PointField.BEARING] = data.bearing;

        // 🏔️ Elevation
        this.chunks[chunkIndex][fieldOffset + PointField.ELEVATION] = data.elevation;

        // 📐 Grade
        this.chunks[chunkIndex][fieldOffset + PointField.GRADE] = data.grade;

        // Radius
        this.chunks[chunkIndex][fieldOffset + PointField.RADIUS] = data.radius;

        // Aero coef
        this.chunks[chunkIndex][fieldOffset + PointField.AERO_COEF] = data.aeroCoef;

        // Cyclist wind
        this.chunks[chunkIndex][fieldOffset + PointField.WIND_BEARING] = data.windBearing;
        this.chunks[chunkIndex][fieldOffset + PointField.WIND_ALPHA] = data.windAlpha;

        // ⚡ Power Physics
        this.chunks[chunkIndex][fieldOffset + PointField.P_AERO] = data.pAero;
        this.chunks[chunkIndex][fieldOffset + PointField.P_GRAVITY] = data.pGravity;
        this.chunks[chunkIndex][fieldOffset + PointField.P_ROLLING_RESISTANCE] =
            data.pRollingResistance;
        this.chunks[chunkIndex][fieldOffset + PointField.P_WHEEL_BEARINGS] = data.pWheelBearings;

        // ⚡ Power Cyclist
        this.chunks[chunkIndex][fieldOffset + PointField.P_INPUT_POWER] = data.pInputPower;
        this.chunks[chunkIndex][fieldOffset + PointField.P_CYCLIST_PROVIDED_OPTIMAL_POWER] =
            data.pCyclistProvidedOptimalPower;
        this.chunks[chunkIndex][
            fieldOffset + PointField.P_CYCLIST_PROVIDED_OPTIMAL_POWER_HARMONICS
        ] = data.pCyclistProvidedOptimalPowerWithHarmonics;
        this.chunks[chunkIndex][fieldOffset + PointField.P_CYCLIST_PROVIDED_POWER_NEEDED] =
            data.pCyclistPowerNeeded;
        this.chunks[chunkIndex][fieldOffset + PointField.P_CYCLIST_PROVIDED_MUSCULAR] =
            data.pCyclistProvidedMuscular;
        this.chunks[chunkIndex][fieldOffset + PointField.P_CYCLIST_PROVIDED_WHEEL] =
            data.PCyclistProvidedWheel;

        // ⚡ Power Post processed
        this.chunks[chunkIndex][fieldOffset + PointField.P_COMPUTED_TOTAL_POWER] =
            data.pComputedTotalPower;
        this.chunks[chunkIndex][fieldOffset + PointField.P_COMPUTED_WHEEL_POWER] =
            data.pComputedWheelPower;
        this.chunks[chunkIndex][fieldOffset + PointField.POWER] = data.pComputedPower;

        // Speed & Motion
        this.chunks[chunkIndex][fieldOffset + PointField.SPEED] = data.speed;
        this.chunks[chunkIndex][fieldOffset + PointField.SPEED_MAX] = data.speedMax;
        this.chunks[chunkIndex][fieldOffset + PointField.SPEED_MAX_INCLINE] = data.speedMaxIncline;
        this.chunks[chunkIndex][fieldOffset + PointField.VIRT_SPEED_CURRENT] =
            data.virtSpeedCurrent;

        // Environmental
        this.chunks[chunkIndex][fieldOffset + PointField.TEMPERATURE] = data.temperature;
        this.chunks[chunkIndex][fieldOffset + PointField.WIND_SPEED] = data.windSpeed;
        this.chunks[chunkIndex][fieldOffset + PointField.WIND_DIRECTION] = data.windDirection;

        // Physiological
        this.chunks[chunkIndex][fieldOffset + PointField.HEART_RATE] = data.heartRate;
        this.chunks[chunkIndex][fieldOffset + PointField.CADENCE] = data.cadence;

        return pointIndex;
    }

    /**
     * Gets all data for a specific point.
     */
    getPointData(pointIndex: number): Point {
        const chunkIndex = Math.floor(pointIndex / this.CHUNK_SIZE);
        const pointInChunk = pointIndex % this.CHUNK_SIZE;
        const fieldOffset = pointInChunk * FIELDS_PER_POINT;
        return {
            // Coordinates
            latitude: this.chunks[chunkIndex][fieldOffset + PointField.LATITUDE],
            longitude: this.chunks[chunkIndex][fieldOffset + PointField.LONGITUDE],
            distance: this.chunks[chunkIndex][fieldOffset + PointField.DISTANCE],
            dx: this.chunks[chunkIndex][fieldOffset + PointField.DX],
            // Temporal
            time: this.chunks[chunkIndex][fieldOffset + PointField.TIME],
            elapsed: this.chunks[chunkIndex][fieldOffset + PointField.ELAPSED],
            dt: this.chunks[chunkIndex][fieldOffset + PointField.DT],
            // Angles
            bearing: this.chunks[chunkIndex][fieldOffset + PointField.BEARING],
            // 🏔️ Elevation
            elevation: this.chunks[chunkIndex][fieldOffset + PointField.ELEVATION],
            // 📐 Grade
            grade: this.chunks[chunkIndex][fieldOffset + PointField.GRADE],
            // Radius
            radius: this.chunks[chunkIndex][fieldOffset + PointField.RADIUS],
            // Aero coef
            aeroCoef: this.chunks[chunkIndex][fieldOffset + PointField.AERO_COEF],
            // Cyclist wind
            windBearing: this.chunks[chunkIndex][fieldOffset + PointField.WIND_BEARING],
            windAlpha: this.chunks[chunkIndex][fieldOffset + PointField.WIND_ALPHA],
            // ⚡ Power Physics
            pAero: this.chunks[chunkIndex][fieldOffset + PointField.P_AERO],
            pGravity: this.chunks[chunkIndex][fieldOffset + PointField.P_GRAVITY],
            pRollingResistance:
                this.chunks[chunkIndex][fieldOffset + PointField.P_ROLLING_RESISTANCE],
            pWheelBearings: this.chunks[chunkIndex][fieldOffset + PointField.P_WHEEL_BEARINGS],
            // ⚡ Power Cyclist
            pInputPower: this.chunks[chunkIndex][fieldOffset + PointField.P_INPUT_POWER],
            pCyclistProvidedOptimalPower:
                this.chunks[chunkIndex][fieldOffset + PointField.P_CYCLIST_PROVIDED_OPTIMAL_POWER],
            pCyclistProvidedOptimalPowerWithHarmonics:
                this.chunks[chunkIndex][
                    fieldOffset + PointField.P_CYCLIST_PROVIDED_OPTIMAL_POWER_HARMONICS
                ],
            pCyclistPowerNeeded:
                this.chunks[chunkIndex][fieldOffset + PointField.P_CYCLIST_PROVIDED_POWER_NEEDED],
            pCyclistProvidedMuscular:
                this.chunks[chunkIndex][fieldOffset + PointField.P_CYCLIST_PROVIDED_MUSCULAR],
            PCyclistProvidedWheel:
                this.chunks[chunkIndex][fieldOffset + PointField.P_CYCLIST_PROVIDED_WHEEL],
            // ⚡ Power Post processed
            pComputedTotalPower:
                this.chunks[chunkIndex][fieldOffset + PointField.P_COMPUTED_TOTAL_POWER],
            pComputedWheelPower:
                this.chunks[chunkIndex][fieldOffset + PointField.P_COMPUTED_WHEEL_POWER],
            pComputedPower: this.chunks[chunkIndex][fieldOffset + PointField.POWER],
            // Speed & Motion
            speed: this.chunks[chunkIndex][fieldOffset + PointField.SPEED],
            speedMax: this.chunks[chunkIndex][fieldOffset + PointField.SPEED_MAX],
            speedMaxIncline: this.chunks[chunkIndex][fieldOffset + PointField.SPEED_MAX_INCLINE],
            virtSpeedCurrent: this.chunks[chunkIndex][fieldOffset + PointField.VIRT_SPEED_CURRENT],
            // Environmental
            temperature: this.chunks[chunkIndex][fieldOffset + PointField.TEMPERATURE],
            windSpeed: this.chunks[chunkIndex][fieldOffset + PointField.WIND_SPEED],
            windDirection: this.chunks[chunkIndex][fieldOffset + PointField.WIND_DIRECTION],
            // Physiological
            heartRate: this.chunks[chunkIndex][fieldOffset + PointField.HEART_RATE],
            cadence: this.chunks[chunkIndex][fieldOffset + PointField.CADENCE],
        };
    }
}
